{
    "dF9w2_U6NzCrnV4Mh5Y4U": {
        "key": "dF9w2_U6NzCrnV4Mh5Y4U",
        "position": {
            "x": 4,
            "y": 1,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/rogue"
    },
    "_bQ9Z_jz8oQv6MnMWNItr": {
        "key": "_bQ9Z_jz8oQv6MnMWNItr",
        "position": {
            "x": 5,
            "y": 4,
            "z": 1
        },
        "affiliation": "bad",
        "maxhealth": 30,
        "jobKey": "hero/berserker"
    },
    "wRoMHZ_HuNiFIbsj9z92q": {
        "key": "wRoMHZ_HuNiFIbsj9z92q",
        "position": {
            "x": 2,
            "y": 5,
            "z": 1
        },
        "affiliation": "bad",
        "maxhealth": 30,
        "jobKey": "hero/berserker"
    }
}